import angular from 'angular'
//import ActivityEdit from 'emun.activity/activity-edit'
import ActivityList from 'emun.activity/activity-list'
import ActivityCalendar from 'emun.activity/activity-calendar'
import ActivityPromptDirective from 'emun.activity/activity-prompt.directive'
import ActivityQuickView from 'emun.activity/activity-quick-view'
import Calendar from 'angular-bootstrap-calendar'

const dependencies = ['emun.auth','webutils', 'webforms', 'webmodals', 'ui.router', Calendar];

export default angular.module('emun.activity', dependencies)
//.component('activityEdit', ActivityEdit)
.component('activityList', ActivityList)
.component('activityCalendar', ActivityCalendar)
.directive('activityPrompt', ActivityPromptDirective)
    .component('activityQuickView', ActivityQuickView)
    .config(['calendarConfig', function (calendarConfig) {
        // View all available config
        //console.log(calendarConfig);
        calendarConfig.allDateFormats.moment.date.weekDay = 'ddd';
        calendarConfig.allDateFormats.moment.date.month = 'MMM';
        calendarConfig.allDateFormats.moment.title.day = 'ddd D MMM, YYYY';
        calendarConfig.allDateFormats.moment.title.month = 'MMM, YYYY';
    }])
.name;